import React, { useEffect } from "react";
import {
  File,
  FileNew,
  TitleDocument,
  useStyles,
  Wrapper,
  WrapperFiles,
} from "./style";
import TreeItems from "./tree";
import Button from "@mui/material/Button";
import OptionMenuDocPlace from "./optionsMenu";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { confirmAlert } from "react-confirm-alert";
import { useNavigate, useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { formatDateTime, PERIOD_OPTIONS } from "../../../../helpers/dateUtils";

import "react-confirm-alert/src/react-confirm-alert.css";
import { getDocumentPermissions } from "../../../../store/document/actions";
import {
  postDocDownload,
  postFolderDownloadZip,
} from "../../../../store/explorer/actions";
import iconFolder from "../../../../assets/yellow.svg";
import reviewal from "../../../../assets/blue.svg";
import Typography from "@mui/material/Typography";
//import document from '../../../../assets/document.svg';
import { Nb_DocumentCard } from "../../../../components/documentCard/documentCard";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import fileExcel from "../../../../assets/file-excel.png";
import filePdf from "../../../../assets/file-pdf.png";
import fileDoc from "../../../../assets/file-doc.png";
import fileWord from "../../../../assets/file-word.png";
import fileImage from "../../../../assets/file-jpg.png";
import fileOther from "../../../../assets/file-other.png";
import fileZip from "../../../../assets/file-zip.png";
import openLocationIcon from "../../../../assets/openLocation.svg";
import openIcon from "../../../../assets/open.svg";
import docAssistantIcon from "../../../../assets/docAssistant.svg";
import downloadIcon from "../../../../assets/download.svg";
import moveIcon from "../../../../assets/move.svg";
import shareIcon from "../../../../assets/share.svg";
import renameIcon from "../../../../assets/rename.svg";
import reprocessIcon from "../../../../assets/reprocess.svg";
import propertiesIcon from "../../../../assets/properties.svg";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import deleteIcon from "../../../../assets/delete.svg";

import Drawer from "@material-ui/core/Drawer";
import { MoveDocPlace } from "./move";
import { ShareDocPlace } from "./share";
import { RenameDocPlace } from "./raname";
import { ReprocessDocPlace } from "./reprocess";
import { RecoverDocPlace } from "./recover";

import TextField from "@material-ui/core/TextField";
import { toast } from "react-toastify";
import Grid from "@mui/material/Grid";
import FileUploadDocPlace from "../fileUpload/fileUpload";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import LoadingComponent from "../../../../components/loading";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import folderGray from "../../../../assets/folder_gray.svg";
import TablePagination from "@mui/material/TablePagination";
import { colors } from "../../../../components/theme";

let deleteWord = "";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));
var folders = [];
var documents = [];
var allDocuments = [];
var firstSelected = "";
var lastSelected = "";

export function FileDocPlace(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let params = useParams();
  const [item, setItem] = React.useState(0);
  const [showOption, setShowOption] = React.useState(false);
  const [showMove, setShowMove] = React.useState(false);
  const [showShare, setShowShare] = React.useState(false);
  const [showRename, setShowRename] = React.useState(false);
  const [showReprocess, setShowReprocess] = React.useState(false);
  const [showRecover, setShowRecover] = React.useState(false);
  const [viewAll, setViewAll] = React.useState(false);

  const [showNewFolder, setShowNewFolder] = React.useState(false);
  const [totalFiles, setTotalFiles] = React.useState([]);
  const [updateAllFiles, setUpdateAllFiles] = React.useState(false);
  const [closeUploadFiles, setCloseUploadFiles] = React.useState(false);
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [permissions, setPermissions] = React.useState(false);
  const [isTrash, setIsTrash] = React.useState(false);
  const [showOption2, setShowOption2] = React.useState(false);

  const { responseDocDownload, loadingDocDownload } = useSelector((state) => ({
    responseDocDownload: state.Explorer.responseDocDownload,
    loadingDocDownload: state.Explorer.loadingDocDownload,
  }));
  const { responseDocumentPermissions, loadingDocumentPermissions } =
    useSelector((state) => ({
      responseDocumentPermissions:
        state.DetailFolder.responseDocumentPermissions,
      loadingDocumentPermissions: state.DetailFolder.loadingDocumentPermissions,
    }));

  const { responseFolderDownload, loadingFolderDownload } = useSelector(
    (state) => ({
      responseFolderDownload: state.Explorer.responseFolderDownload,
      loadingFolderDownload: state.Explorer.loadingFolderDownload,
    })
  );

  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(menuAnchorEl);
  const handleMenuClick = (event, item) => {
    setItem(item);
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const [objs, setObjs] = React.useState([]);
  const [originalFiles, setOriginalFiles] = React.useState([]);
  useEffect(() => {
    setCloseUploadFiles(props.closeUp);
    if (props.closeUp) {
      setTotalFiles([]);
    }
  }, [props.closeUp]);

  useEffect(() => {
    setIsTrash(props.isTrash);
  }, [props.isTrash]);

  useEffect(() => {
    setOriginalFiles([].concat(props.file));
    const firstEightFiles = props.file.slice(0, 8);
    setObjs([].concat(firstEightFiles));
  }, [props.file]);

  const toggleViewAll = () => {
    setViewAll(!viewAll);
    if (viewAll) {
      setObjs(originalFiles.slice(0, 8));
    } else {
      setObjs(originalFiles);
    }
  };

  useEffect(() => {
    if (props.reset == true) {
      setPage(1);
      setRowsPerPage(100);
      props.resetDone();
    }
  }, [props.reset]);

  useEffect(() => {
    if (props.file.length === 0) {
      const filtered = props.file.filter((item) => {
        const dateStr = item?.fkArchive?.createdAt;
        if (!dateStr) return true;
        const createdAt = new Date(dateStr);
        const daysAgo = new Date();
        daysAgo.setDate(daysAgo.getDate() - props.daysFilter);
        return createdAt >= daysAgo;
      });

      setObjs(filtered);
    }
  }, [props.file, props.daysFilter]);

  useEffect(() => {
    if (responseDocDownload) {
      const blob = new Blob([responseDocDownload], {
        type: "application/octetstream",
      });
      const link = document.createElement("a");
      const lastIndex = item?.fkArchive?.name?.lastIndexOf(".");
      const nameSplit = item?.fkArchive
        ? item?.fkArchive?.name?.slice(0, lastIndex)
        : "";
      link.href = URL.createObjectURL(blob);
      link.download = item.fkArchive
        ? item.fkArchive?.originalExtension
          ? nameSplit + item.fkArchive.originalExtension
          : item.fkArchive?.name
        : "";
      // some browser needs the anchor to be in the doc
      if (link.download) {
        document.body.append(link);
        link.click();
      }
      link.remove();
      // in case the Blob uses a lot of memory
      setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    }
  }, [responseDocDownload]);

  useEffect(() => {
    if (responseDocumentPermissions) {
      setPermissions(responseDocumentPermissions);
    }
  }, [responseDocumentPermissions]);

  const updateFile = (files) => {
    if (files.length > 0) {
      props.updateFile(files);
    }
    setCloseUploadFiles(false);
    setTotalFiles(files);
  };

  const clickItem = (item, event) => {
    dispatch(getDocumentPermissions(item.fkArchive.id, navigate));
    setTimeout(() => {
      setShowOption(true);
    }, 200);
    setItem(item);
    setSelectedFiles([]);
    props.clickItem(item, event);
  };

  const doubleClickItemC = (item, evt) => {
    const isFolder = item.folder || item.fkArchive?.type === "Folder";

    if (isFolder) {
      const send = {
        label: item.fkArchive.name,
        parent: null,
        value: item.fkArchive.id,
      };
      callItemTree(send);
    } else {
      props.openFile(item);
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setShowOption2(open);
    setShowOption(open);
  };

  const closeModal = () => {
    setShowMove(false);
    setShowShare(false);
    setShowRename(false);
    setShowNewFolder(false);
    setShowReprocess(false);
    setShowRecover(false);
  };

  const optionMenu = (opt, itemEl) => {
    console.log(opt);
    console.log('opt', opt);
    console.log('itemEl', itemEl);
    var itemInfo;
    if (item.fkArchive) {
      itemInfo = item;
    } else {
      itemInfo = itemEl;
    }
    let type = itemInfo?.folder ? "Folder" : itemInfo.fkArchive.type;

    switch (opt) {
      case "properties": {
        setShowOption2(true);
        return null;
      }
      case "open": {
        if (type === "Folder") {
          let send = {
            label: itemInfo.fkArchive.name,
            parent: null,
            value: itemInfo.fkArchive.id,
          };
          callItemTree(send);
          setShowOption(false);
        } else {
          props.openFile(itemInfo);
          setShowOption(false);
        }
        return null;
      }
      case "download": {
        let type = itemInfo.fkArchive?.originalExtension
          .toUpperCase()
          .replace(".", "");

        dispatch(
          postDocDownload(
            {
              archiveId: itemInfo.fkArchive.id,
              fileName: itemInfo.fileReferences.originalFileName
                ? itemInfo.fileReferences.originalFileName
                : itemInfo.fkArchive.name,
              type: type,
            },
            navigate
          )
        );
        setShowOption(false);
        return null;
      }
      case "downloadZip": {
        let folderName = itemInfo.fileReferences.originalFileName
          ? itemInfo.fileReferences.originalFileName
          : itemInfo.fkArchive.name;
        let obj = [itemInfo.fkArchive.id];
        dispatch(postFolderDownloadZip(folderName, obj));
        setShowOption(false);
        return null;
      }
      case "move": {
        setShowMove(true);
        setShowOption(false);
        return null;
      }
      case "rename": {
        setShowRename(true);
        setShowOption(false);
        return null;
      }
      case "delete": {
        deleteItem(itemInfo);
        setShowOption(false);
        return null;
      }
      case "share": {
        setShowShare(true);
        setShowOption(false);
        return null;
      }
      case "reprocess": {
        setShowReprocess(true);
        setShowOption(false);
        return null;
      }
      case "recover": {
        setShowRecover(true);
        setShowOption(false);
        return null;
      }
      case "fileLocation": {
        if (itemInfo.fkArchive.parentArchiveId) {
          const itemToNavigate = {
            label: itemInfo.fkArchive.name,
            value: itemInfo.fkArchive.id,
          };
          backTree(itemToNavigate);
        }
        setShowOption(false);
        return null;
      }
      case "open location": {
        console.log('itemEl?.fkArchive?.id', itemEl?.fkArchive?.id);
        //redirect to explorer page
        navigate(`/explorer/${itemEl?.fkArchive?.id}`);
        setShowOption(false);
        return null;
      }
      default: {
        return null;
      }
    }
  };
  const deleteItem = (_item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="deleteConfirm custom-ui">
            <h1 style={{ margin: "-43px 0px 0px 0px" }}>Are you sure?</h1>
            <p>
              Write the text "DELETE" in the following box and confirm the
              deletion of the item. The item will be moved to the trash bin and
              remain there for 30 days before being permanently deleted
            </p>

            <TextField
              style={{
                width: "100%",
                backgroundColor: "#fff",
                marginBottom: "26px",
              }}
              id="delete"
              variant="outlined"
              onChange={(e) => (deleteWord = e.target.value)}
              label="Write DELETE"
            />

            <Button className={classes.btnCancel} autoFocus onClick={onClose}>
              NO
            </Button>

            <Button
              className={classes.btnDelete}
              autoFocus
              onClick={() => {
                if (deleteWord === "DELETE") {
                  deleteWord = "";
                  callDelete(_item);
                  onClose();
                } else {
                  toast.error("Wrong Key!");
                }
              }}
            >
              Yes, Delete it!
            </Button>
          </div>
        );
      },
    });
  };

  const callDelete = (_item) => {
    props.deleteFile({ deleteFiles: true, item: _item });
  };

  const setNewTree = (obj) => {
    if (obj === null || obj === undefined) return;
    for (const [k, v] of Object.entries(obj)) {
      obj["hola"] = obj["name"];
      setNewTree(v);
    }
  };

  const callMove = (moveFile) => {
    setShowMove(false);
    props.moveFile();
  };

  const callShare = (shareFiles) => {
    setShowShare(false);
    props.shareFile({ shareFiles: shareFiles, item: item });
  };

  const callRename = (renameFiles) => {
    setShowRename(false);
    props.renameFile();
  };

  const callReprocess = (reprocessFiles) => {
    setShowReprocess(false);
    //props.reprocessFile(reprocessFiles);
  };
  const callRecover = (recoverFiles) => {
    setShowRecover(false);
    //props.recoverFile();
  };

  const callUpdateContent = (content) => {
    setShowRename(false);
    props.updateFile({ updateFile: content, item: item });
  };

  const callAddComment = (comment) => {
    setShowRename(false);
    setShowOption(false);
    props.addComment({ comment: comment, item: item });
  };

  const callItemTree = (item) => {
    props.clickTree(item);
  };

  const backTree = (item) => {
    props.backTree(item);
  };

  const formatFileSize = (sizeInBytes) => {
    if (!sizeInBytes || Number.isNaN(sizeInBytes)) return null;

    const sizeMB = sizeInBytes / 1_000_000;

    if (sizeMB >= 1000) {
      const sizeGB = sizeMB / 1000;
      return `${sizeGB.toFixed(2)} GB`;
    }

    return `${sizeMB.toFixed(2)} MB`;
  };
  const setFileType = (file) => {
    // Get extension from originalExtension field, fallback to filename if empty
    let extension = file.fkArchive?.originalExtension?.toString().toLowerCase();

    // If originalExtension is empty or not available, extract from filename
    if (!extension || extension === "") {
      const fileName = file.fkArchive?.name || "";
      const lastDotIndex = fileName.lastIndexOf(".");
      if (lastDotIndex > 0) {
        extension = fileName.substring(lastDotIndex).toLowerCase();
      }
    }

    switch (extension) {
      case ".pdf":
        return filePdf;
      case ".doc":
      case ".docx":
        return fileWord;
      case ".jpg":
      case ".png":
      case ".jpeg":
        return fileImage;
      case ".xls":
      case ".csv":
      case ".xlsx":
        return fileExcel;
      case ".zip":
        return fileZip;
      case ".txt":
        return fileDoc;
      default:
        return fileOther;
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    props.nextPage(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    props.nextPage(0, parseInt(event.target.value, 10));
    setPage(0);
  };

  const onlyFiles = objs.filter(
    (item) => !item.folder && item.fkArchive?.type !== "Folder"
  );

  const scrollStyles =
    props.viewMode === "list"
      ? props.showAllFiles
        ? {
            minHeight: "300px",
            maxHeight: "calc(100vh - 190px)",
            overflowY: "auto",
            overflowX: "visible",
            paddingRight: "4px",
            position: "relative",
          }
        : {
            // When not showing all, we only render up to 8 items, so don't force empty space.
            minHeight: "auto",
            maxHeight: "none",
            overflow: "visible",
            paddingRight: "4px",
            position: "relative",
          }
      : {
          // grid-view: take all the space, no scrollbar, no border
          maxHeight: "none",
          minHeight: "auto",
          overflow: "visible",
          padding: 0,
          border: "none",
          background: "transparent",
        };

  return (
    <Wrapper>
      <Drawer anchor="bottom" open={showOption2} onClose={toggleDrawer(false)}>
        <div onClick={toggleDrawer(false)} className={classes.closeOpt}>
          CLOSE
        </div>
        <OptionMenuDocPlace
          addComment={callAddComment.bind(this)}
          updateFile={callUpdateContent.bind(this)}
          click={optionMenu.bind(this)}
          item={item}
          isTrash={isTrash}
          permissions={permissions}
          hideFileLocationOption
        />
      </Drawer>
      <LoadingComponent
        show={loadingDocDownload}
        text={"Downloading Document..."}
      />
      <LoadingComponent
        show={loadingFolderDownload}
        text={"Downloading Document..."}
      />
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <WrapperFiles id="scrollableDiv">
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
                marginTop: "8px",
                width: "100%",
              }}
            >
              <Typography
                variant="h6"
                style={{
                  fontWeight: "bold",
                  color: "#0076FF",
                }}
              >
                Recent Files
              </Typography>

              <select
                value={props.daysFilter || PERIOD_OPTIONS[0].days}
                onChange={(e) => props.setDaysFilter(parseInt(e.target.value))}
                style={{
                  color: "#0076FF",
                  fontSize: "14px",
                  backgroundColor: "transparent",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                  appearance: "auto",
                  WebkitAppearance: "auto",
                  MozAppearance: "auto",
                }}
              >
                {PERIOD_OPTIONS.map((option) => (
                  option.days !== null && (
                    <option key={option.value} value={option.days}>
                      {option.label}
                    </option>
                  )
                ))}
              </select>
            </div>

            {(() => {
              const shouldShowLoading = 
                props.loadingRecent === true || 
                ((!props.file || props.file.length === 0) && !props.hasReceivedResponse && !props.errorRecent);
              
              return shouldShowLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "60px 20px",
                    minHeight: "200px",
                    width: "100%",
                  }}
                >
                  <CircularProgress size={40} sx={{ color: "#0076FF", mb: 2 }} />
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#0076FF",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Loading recent files...
                  </Typography>
                </Box>
              ) : (
              <div className={classes.scrollableRecentFiles} style={scrollStyles}>
                {props.viewMode === "list" ? (
                  (props.showAllFiles ? objs : objs.slice(0, 8))
                    .filter(
                      (item) => !item.folder && item.fkArchive?.type !== "Folder"
                    )
                    .map((item, idx) => {
                    const isFolder =
                      item.folder || item.fkArchive?.type === "Folder";
                    const name = item.fkArchive?.name;
                    const rawSize =
                      item.fkArchive?.size ??
                      item?.size ??
                      item?.fileSize ??
                      item?.fileReferences?.fileSize;
                    const sizeLabel = formatFileSize(rawSize);

                    return (
                      <div
                        key={idx}
                        className={`${classes.listItem} ${
                          idx % 2 === 0 ? classes.rowEven : classes.rowOdd
                        }`}
                        onDoubleClick={(e) => doubleClickItemC(item, e)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className={classes.iconAndName}>
                          <img
                            src={isFolder ? iconFolder : setFileType(item)}
                            alt="file-icon"
                            className={classes.iconImage}
                          />
                          <div
                            className={classes.listFileName}
                            style={{ color: "#0076FF", fontWeight: "bold" }}
                          >
                            {name}
                          </div>
                        </div>

                        <Tooltip
                          title={
                            item?.fkArchive?.docType?.name ||
                            item?.fkDoctype?.name ||
                            "-"
                          }
                          enterDelay={300}
                          placement="top-start"
                        >
                          <div className={classes.listDocType}>
                            {item?.fkArchive?.docType?.name ||
                              item?.fkDoctype?.name ||
                              "-"}
                          </div>
                        </Tooltip>

                        <div className={classes.listFileSize}>
                          {!isFolder ? (sizeLabel != null ? sizeLabel : "-") : "-"}
                        </div>

                        <div className={classes.listFileType}>
                          {!isFolder
                            ? item?.fkArchive?.originalExtension
                                ?.replace(".", "")
                                .toUpperCase() ||
                              item?.fkArchive?.type ||
                              "-"
                            : "Folder"}
                        </div>

                        <div className={classes.listTimestamp}>
                          {formatDateTime(item?.fkArchive?.createdAt || item?.createdAt)}
                        </div>

                        <div style={{ textAlign: "right" }}>
                          <IconButton onClick={(e) => handleMenuClick(e, item)}>
                            <MoreVertIcon />
                          </IconButton>
                        </div>
                      </div>
                    );
                  })
              ) : (
                <div
                  className={classes.float_center}
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                    gap: "20px 14px",
                    padding: "10px 0",
                  }}
                >
                  {(() => {
                    const onlyFiles = objs.filter(
                      (item) =>
                        !item.folder && item.fkArchive?.type !== "Folder"
                    );

                    const toShow = props.showAllFiles
                      ? onlyFiles
                      : onlyFiles.slice(0, 8);

                    return toShow.map((item, idx) => (
                      <div
                        key={idx}
                        onDoubleClick={() => doubleClickItemC(item)}
                        style={{ cursor: "pointer" }}
                      >
                        <Nb_DocumentCard
                          fileName={item.fkArchive?.name}
                          iconImg={setFileType(item)}
                          id={idx}
                          listContextMenu={[
                            { id: "1", name: "Open", iconImg: openIcon },
                            // { id: '2', name: 'DocAssistant', iconImg: docAssistantIcon },
                            {
                              id: "3",
                              name: "Download",
                              iconImg: downloadIcon,
                            },
                            { id: "4", name: "Move", iconImg: moveIcon },
                            { id: "5", name: "Share", iconImg: shareIcon },
                            { id: "6", name: "Rename", iconImg: renameIcon },
                            {
                              id: "7",
                              name: "Reprocess",
                              iconImg: reprocessIcon,
                            },
                            {
                              id: "10",
                              name: "Open Location",
                              iconImg: openLocationIcon,
                            },
                            {
                              id: "8",
                              name: "Properties",
                              iconImg: propertiesIcon,
                            },
                            { id: "9", name: "Delete", iconImg: deleteIcon },
                          ]}
                          onClickItemList={(action) => {
                            setItem(item);
                            optionMenu(action.name.toLowerCase(), item);
                          }}
                        />
                      </div>
                    ));
                  })()}
                </div>
              )}
              </div>
              );
            })()}

            <Menu
              anchorEl={menuAnchorEl}
              open={isMenuOpen}
              onClose={handleMenuClose}
            >
              {[
                { id: "1", name: "Open", iconImg: openIcon },
                // { id: "2", name: "DocAssistant", iconImg: docAssistantIcon },
                { id: "3", name: "Download", iconImg: downloadIcon },
                { id: "4", name: "Move", iconImg: moveIcon },
                { id: "5", name: "Share", iconImg: shareIcon },
                { id: "6", name: "Rename", iconImg: renameIcon },
                { id: "7", name: "Reprocess", iconImg: reprocessIcon },
                {
                  id: "10",
                  name: "Open Location",
                  iconImg: openLocationIcon,
                },
                { id: "8", name: "Properties", iconImg: propertiesIcon },
                { id: "9", name: "Delete", iconImg: deleteIcon },
              ].map((action) => (
                <MenuItem
                  key={action.id}
                  onClick={() => {
                    optionMenu(action.name.toLowerCase(), item);
                    handleMenuClose();
                  }}
                >
                  <img
                    src={action.iconImg}
                    alt={action.name}
                    style={{ width: 16, height: 16, marginRight: 8 }}
                  />
                  {action.name}
                </MenuItem>
              ))}
            </Menu>
          </WrapperFiles>
        </Grid>
      </Grid>
      <Drawer anchor="bottom" open={showOption} onClose={toggleDrawer(false)}>
        <div onClick={toggleDrawer(false)} className={classes.closeOpt}>
          CLOSE
        </div>
        <OptionMenuDocPlace
          addComment={callAddComment.bind(this)}
          updateFile={callUpdateContent.bind(this)}
          click={optionMenu.bind(this)}
          item={item}
          isTrash={isTrash}
          permissions={permissions}
          hideFileLocationOption
        />
      </Drawer>

      <Grid item xs={12} style={{ textAlign: "center" }}>
        <Button
          onClick={toggleViewAll}
          variant="outlined"
          style={{
            fontWeight: "bold",
            fontSize: "12px",
            padding: "4px 10px",
            position: "relative",
            minWidth: "auto",
            textTransform: "none",
            color: colors.blue,
            backgroundColor: "#fff",
            marginTop: "-24px",
          }}
        >
          {viewAll ? "Show Less" : "View All"}
        </Button>
      </Grid>

      <RenameDocPlace
        rename={callRename.bind(this)}
        itemRename={item}
        close={closeModal.bind(this)}
        show={showRename}
      />
      <ReprocessDocPlace
        reprocess={callReprocess.bind(this)}
        itemReprocess={item}
        close={closeModal.bind(this)}
        show={showReprocess}
      />
      <RecoverDocPlace
        recover={callRecover.bind(this)}
        itemRecover={item}
        close={closeModal.bind(this)}
        show={showRecover}
      />
      <ShareDocPlace
        share={callShare.bind(this)}
        itemShare={item}
        users={props.users}
        close={closeModal.bind(this)}
        show={showShare}
      />
      <MoveDocPlace
        backTree={backTree.bind(this)}
        treePrevius={props.treePrevius}
        move={callMove.bind(this)}
        tree={props.tree}
        close={closeModal.bind(this)}
        itemMove={item}
        show={showMove}
      />
    </Wrapper>
  );
}
export default FileDocPlace;
